(function ($) {
  'use strict';

  window.ys.lv2026 = new LaVuelta2026();

  /**
   * Initialize the quiz
   */
  if ($('body').hasClass('lv_2026')) {
    window.ys.lv2026Contest = new LaVuelta2026.Contest();
    console.log('lv_2026');
  }

  $(document).ready(function () {
    function initializeFlickity() {
      var $carousel = $('.carousel-posts-carousel');
      var flkty;

      if (window.matchMedia('(max-width: 768px)').matches) {
        flkty = $carousel.flickity({
          wrapAround: true,
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 40,
          },
        });
      } else {
        flkty = $carousel.flickity({
          wrapAround: true,
          cellAlign: 'left',
          arrowShape: {
            x0: 25,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 40,
          },
        });
      }

      return flkty;
    }

    // Initialize Flickity on page load
    var flkty = initializeFlickity();

    // Re-initialize Flickity on window resize
    window.addEventListener('resize', function () {
      // Destroy the current instance and re-initialize
      $('.carousel-posts-carousel').flickity('destroy');
      flkty = initializeFlickity();
    });
  });
}).bind(window)(jQuery);
